import { Module } from 'vuex'
import { RootState, Collection } from '../store-types'
import { MetaPayload } from '@/core/utils/pagination'
import { useAdviceSectionHttp } from '@/core/api/advice-sections'
import { AdviceSection, AdviceSectionPayload } from '@/core/models/advice-section'

export type AdviceSectionCollection = {
    data: Array<AdviceSection>,
    meta?: MetaPayload,
    links?: any
}

const state: AdviceSectionCollection = {
    data: <any>[],
    meta: <any>[],
    links: <any>[],
}

export const adviceSectionCollection: Module<AdviceSectionCollection, RootState> = {
    namespaced: true,
    state,
    mutations: {
        set: (state: AdviceSectionCollection, payload: Collection) => {
            state.data = <any>[]
            payload.data.forEach((item: AdviceSectionPayload) => {
                state.data.push(new AdviceSection(item))
            })
            state.meta = payload.meta
            state.links = payload.links
        },
    },
    actions: {
        get: <T>(context: any, payload: any): Promise<T> => {
            return new Promise<T>((resolve, reject) => {
                useAdviceSectionHttp()
                    .get(payload)
                    .then((data: any) => {
                        context.commit('set', data)
                        resolve(data as T)
                    })
                    .catch((response: any) => {
                        reject(response as T)
                    })
            })
        }
    },
    getters: {
        get: (state: AdviceSectionCollection): AdviceSectionCollection => {
            return state
        }
    }
}
